/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SFTPDataSourceInternalResponse } from '../models/SFTPDataSourceInternalResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalService {

    /**
     * Get list of companyJobs that don't exist in tenant's db
     * @returns string Success
     * @throws ApiError
     */
    public static getMissingJobCodes({
        requestBody,
    }: {
        requestBody: {
            jobCodes: Array<string>;
        },
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/getMissingJobCodes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of mismatched combination of Company Job Family / Subfamily
     * @returns any Success
     * @throws ApiError
     */
    public static getMismatchJobFamilies({
        requestBody,
    }: {
        requestBody: {
            jobFamilies: Array<{
                job_family: string;
                job_subfamily: string;
            }>;
        },
    }): CancelablePromise<Array<{
        job_family: string;
        job_subfamily: string;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/getMismatchJobFamilies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of mismatched combination of Company Job Level / Category
     * @returns any Success
     * @throws ApiError
     */
    public static getMismatchJobLevels({
        requestBody,
    }: {
        requestBody: {
            jobLevels: Array<{
                job_category: string;
                job_level: string;
            }>;
        },
    }): CancelablePromise<Array<{
        job_category: string;
        job_level: string;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/getMismatchJobLevels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get SFTP Data Sources
     * @returns SFTPDataSourceInternalResponse Success
     * @throws ApiError
     */
    public static getSftpDataSources(): CancelablePromise<Array<SFTPDataSourceInternalResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/getSFTPDataSources',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Current Plan
     * @returns any Success
     * @throws ApiError
     */
    public static getCurrentPlan(): CancelablePromise<{
        /**
         * The ID of the current plan, or null if no current plan exists
         */
        planId?: number | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/getCurrentPlan',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
